import { type FC } from 'react'
import { useDocumentWorkflowLauncher } from './useDocumentWorkflowLauncher'
import { WorkflowsMenu } from './WorkflowsMenu'

export interface DocumentWorkflowsMenuProps {
  documentId: string
}

export const DocumentWorkflowsMenu: FC<DocumentWorkflowsMenuProps> = ({ documentId }) => {
  const launcher = useDocumentWorkflowLauncher(documentId)
  return <WorkflowsMenu launcher={launcher} />
}
